<div class="container-fluid">
    <div class="row">
        <div class="col-md-3" >
            <a routerLink="/naac/ssr/criteria6/6-1"> <i class="fas fa-long-arrow-alt-left"></i> Go Back</a>
            <nav id="secondary-navigation">
                <!-- Header -->
                <header class="header">
                    <h5>6.1.1</h5>
                </header>
                <!-- /Header -->
                <ul>
                    <li class="first">
                        <a (click)="changeRoute('1')">ADVISORY COMMITTEE</a>
                    </li>
                    <li class="second">
                        <a (click)="changeRoute('2')">DECENTRALIZATION IN INSTITUTIONAL GOVERNANCE</a>
                    </li>
                    <li class="third">
                        <a (click)="changeRoute('3')">VISION MISSION</a>
                    </li>
                </ul>
            </nav>
        </div>
        <div class="col-md-9">
            <div class="container-fluid pdf">
                <div class="row">
                    <div class="col-12">
                        <div class="card card-body">
                            <h5 class="card-title text-center">VISION MISSION ADVISORY COMMITTEE DECENTERLIZATION</h5>
                            <div id="detail" class="text-center">
                                <pdf-viewer [src]="src" [render-text]="true" style="display: block;" id="list-view"></pdf-viewer>
                            </div>
                        </div>
                    </div>
                </div>
        </div>

        </div>
    </div>
</div>